import { Select } from 'antd';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { company } from '../../../../models/entities/company/company';
import { platformCompaniesSelectors } from '../../../../state/ducks/platformCompanies/selectors';
import { platformSuperAdminSelectors } from '../../../../state/ducks/platformSuperAdmin/selectors';
import { RootState } from '../../../../state/store/store';

type Props = {
    isPlatformSuperAdmin: boolean;
    activeTenantId: string | null;
    companies: company[];
    fetchCompanies: () => void;
    switchTenantView: (tenantId: string | null) => void;
};

const TenantSwitcherHeader = ({
    isPlatformSuperAdmin,
    activeTenantId,
    companies,
    fetchCompanies,
    switchTenantView
}: Props) => {
    useEffect(() => {
        if (isPlatformSuperAdmin) fetchCompanies();
    }, [isPlatformSuperAdmin, fetchCompanies]);

    if (!isPlatformSuperAdmin) return null;

    const formatCompanyLabel = (c: company) => {
        const name = c.name || c.subDomain || c.id;
        if (c.subDomain && c.name) return `${c.name} (${c.subDomain})`;
        return name;
    };

    const options = [
        { value: '', label: 'All organizations' },
        ...companies.map((c) => ({
            value: c.id,
            label: formatCompanyLabel(c)
        }))
    ];

    return (
        <Wrapper>
            <Label>View as</Label>
            <Select
                size="small"
                style={{ minWidth: 180, maxWidth: 240 }}
                value={activeTenantId || ''}
                options={options}
                showSearch
                optionFilterProp="label"
                loading={!companies.length}
                onChange={(value) => switchTenantView(value || null)}
            />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-right: 8px;

    @media screen and (max-width: 768px) {
        display: none;
    }
`;

const Label = styled.span`
    font-size: 12px;
    color: #666;
    white-space: nowrap;
`;

const mapState = (state: RootState) => ({
    isPlatformSuperAdmin: platformSuperAdminSelectors.isPlatformSuperAdmin(state),
    activeTenantId: platformSuperAdminSelectors.activeTenantId(state),
    companies: platformCompaniesSelectors.filteredCompanies(state)
});

const mapDispatch = (dispatch: any) => ({
    fetchCompanies: () => dispatch.platformCompanies.fetchCompanies(),
    switchTenantView: (tenantId: string | null) => dispatch.platformSuperAdmin.switchTenantView(tenantId)
});

export default connect(mapState, mapDispatch)(TenantSwitcherHeader);
